import { render, staticRenderFns } from "./testDiff.vue?vue&type=template&id=04c3e57a&scoped=true&"
import script from "./testDiff.vue?vue&type=script&lang=js&"
export * from "./testDiff.vue?vue&type=script&lang=js&"
import style0 from "./testDiff.vue?vue&type=style&index=0&id=04c3e57a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c3e57a",
  null
  
)

export default component.exports